import { createLocale } from "./createLocale";

export const hr = createLocale({
  header: {
    title: "Postanite globalni. 2 $ po Shortu. Bilo koji jezik!",
    subtitle: "🔥Plaćajte samo za rezultat – od $0.089 do $0.009 po sekundi🔥",
  },
  steps: {
    uploadVideo: "Prenesite video",
    selectLanguages: "Odaberite jezike",
    conversionResult: "Pretvorba i rezultat",
  },
  upload: {
    dragAndDrop: "Povucite i ispustite svoju video datoteku ovdje",
    orClickToSelect: "ili kliknite za odabir",
    supportedFormats: "Podržani formati: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maksimalna veličina datoteke: 200 MB",
    maxDuration: "• Maksimalno trajanje: 30 sek",
    chooseFile: "Odaberi datoteku",
    selectedFile: "Odabrana datoteka:",
    size: "Veličina:",
    fileTypeError: "Odaberite video datoteku",
    fileSizeError: "Veličina datoteke ({size} MB) premašuje maksimalno ograničenje od 200 MB",
    durationError: "Trajanje videa ({duration} sek) premašuje maksimalno ograničenje od 30 sek",
    fileReadError: "Video datoteku nije moguće pročitati. Pokušajte s drugom datotekom.",
  },
  languages: {
    sourceAudioLanguage: "Jezik izvornog zvuka",
    targetAudioLanguage: "Jezik ciljnog zvuka",
    selectLanguage: "Odaberite jezik...",
  },
  conversion: {
    replaceAudio: "Kloniraj moj glas",
    uploadVideoAndSelectLanguages: "Prenesite video i odaberite jezike za nastavak",
  },
  nav: {
    blog: "Blog",
  },
  footer: {
    privacyPolicy: "Pravila privatnosti",
    termsOfUse: "Uvjeti korištenja",
  },
  languageOptions: {
    hr: "Hrvatski",
  },
});
